/**
 * @generated SignedSource<<8e084f9ce2554d271a1ecdf96d74f1e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type LessonBookingDetailsStepNode$data = {
  readonly firstStartSlot?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agenda: {
          readonly facility: {
            readonly club: {
              readonly supportsPrivate: boolean;
            } | null | undefined;
            readonly privateLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
            } | null | undefined;
            readonly publicLessonsPermissionSet: {
              readonly patronAccess: LessonAccess | null | undefined;
            } | null | undefined;
          };
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"GroupSizeControlNode" | "LessonCourseControlNode">;
  readonly " $fragmentType": "LessonBookingDetailsStepNode";
};
export type LessonBookingDetailsStepNode$key = {
  readonly " $data"?: LessonBookingDetailsStepNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonBookingDetailsStepNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilityId"
    },
    {
      "kind": "RootArgument",
      "name": "lessonTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonBookingDetailsStepNode",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupSizeControlNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonCourseControlNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "firstStartSlot",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "fields": [
                {
                  "kind": "Literal",
                  "name": "bookingType",
                  "value": "LESSON"
                },
                {
                  "kind": "Variable",
                  "name": "facilityId",
                  "variableName": "facilityId"
                },
                {
                  "kind": "Variable",
                  "name": "lessonTypeId",
                  "variableName": "lessonTypeId"
                }
              ],
              "kind": "ObjectValue",
              "name": "slotAvailability"
            }
          ],
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "startSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlotEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Agenda",
                      "kind": "LinkedField",
                      "name": "agenda",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "facility",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Club",
                              "kind": "LinkedField",
                              "name": "club",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "supportsPrivate",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PrivateLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "privateLessonsPermissionSet",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PublicLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "publicLessonsPermissionSet",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailabilitySlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "1a14c50c5f3587b36d4da8748b35841a";

export default node;
